import { io, Socket } from 'socket.io-client';

const getSocketUrl = () => {
  return import.meta.env.DEV
    ? window.location.origin
    : (import.meta.env.VITE_API_URL || 'http://localhost:4800');
};

let socket: Socket | null = null;

export const getSocket = () => {
  if (!socket) {
    const url = getSocketUrl();
    const token = localStorage.getItem('token');
    socket = io(url, {
      transports: ['websocket'],
      autoConnect: true,
      withCredentials: true,
      auth: { token },
    });
  }
  return socket;
};

export const reconnectSocket = () => {
  disconnectSocket();
  return getSocket();
};

export const disconnectSocket = () => {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
};
